<script setup lang="ts">
const store = useSongStore();
const items = computed(() =>
  store.song?.media.filter((m) => m.type === "video" && m.artwork).slice(0, 2),
);
const playingIndex = ref(-1);
onMounted(() => {
  emitter.on("youtubeVideoEnded", onYoutubeVideoEnd);
});
onBeforeUnmount(() => {
  emitter.off("youtubeVideoEnded", onYoutubeVideoEnd);
});

function onYoutubeVideoEnd() {
  playingIndex.value = -1;
}
function onClick(ind: number) {
  playingIndex.value = ind;
}
</script>

<template>
  <section v-if="store.status !== LoadStatus.Ready || items?.length">
    <div class="section-title-wrapper">
      <SectionTitle
        ><span v-if="store.status === LoadStatus.Ready">Youtube Videos</span
        ><span
          v-else
          class="placeholder"
          style="width: 100px"
      /></SectionTitle>
    </div>
    <div class="flex flex-wrap items-center gap-4">
      <template v-if="store.status === LoadStatus.Ready">
        <template
          v-for="(i, ind) of items"
          :key="ind"
        >
          <button
            v-if="playingIndex !== ind"
            type="button"
            class="media-item"
            @click="onClick(ind)"
          >
            <div class="relative">
              <AlbumArtwork
                media-type="video"
                :url="i.artwork || undefined"
                :alt="i.title"
                class="thumbnail"
              />
              <div class="artwork-hover">
                <FAIcon class="fa-solid fa-play" />
              </div>
            </div>
            <div class="text-left">{{ i.title }}</div>
          </button>
          <div
            v-else
            class="media-item"
          >
            <div class="youtube-wrapper">
              <FAIcon class="fa-spin fa-spinner-third fa-solid busy-icon" />
              <YouTubePlayer
                :src="i.urls[0].url"
                :thumbnail="i.artwork"
                :alt="i.title"
                class="yt-player"
              />
            </div>
            <div class="text-left">{{ i.title }}</div>
          </div>
        </template>
      </template>
      <template v-else>
        <div class="placeholder aspect-video" />
        <div class="placeholder aspect-video" />
      </template>
    </div>
  </section>
</template>

<style scoped lang="postcss">
.media-item {
  @apply relative aspect-video h-full w-full max-w-[350px] transition-all;
  &:hover,
  &:focus-visible {
    @apply brightness-75;
  }
}
.artwork-hover {
  @apply absolute bottom-5 left-5 right-5 top-5 flex items-end justify-end text-white;
  :deep() {
    i,
    svg {
      @apply text-2xl shadow;
    }
  }
}
.youtube-wrapper {
  @apply relative aspect-video h-full w-full overflow-hidden rounded-lg bg-gray-300;
}

.busy-icon {
  @apply absolute text-white;
  left: 50%;
  top: 50%;
  font-size: 2em;
  margin-left: -0.5em;
  margin-top: -0.5em;
  z-index: 0;
}
:deep() {
  .yt-player {
    @apply absolute bottom-0 left-0 right-0 top-0 z-10;
  }
}
</style>
